import { render, staticRenderFns } from "./upform.vue?vue&type=template&id=92d7069c"
import script from "./upform.vue?vue&type=script&lang=js"
export * from "./upform.vue?vue&type=script&lang=js"
import style0 from "./upform.vue?vue&type=style&index=0&id=92d7069c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports